//
// Visual-to-layout scale of an element, when an ancestor scales it (the
// dashboard shell zoom from DisplayProvider). 1 when unscaled.
//

const getRenderedScale = (element) => {
  const layoutWidth = element?.offsetWidth;
  if (!layoutWidth) return 1;
  const scale = element.getBoundingClientRect().width / layoutWidth;
  if ((!Number.isFinite(scale)) || (scale <= 0)) return 1;
  // offsetWidth is rounded to integer px: snap the resulting noise to 1
  return (Math.abs(scale - 1) < 0.02) ? 1 : scale;
};

export default getRenderedScale;
